import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import NavigatorMain from '../../NavigatorMain';
import { getTempInfo } from '../../../common.js';
import {findCamcHqtExist,getCardByHqt, getCardByHqtOpen, getCardListByCf} from '../../../action/myAssets/userInfoAction'
import { AddCardHqtAlert } from '../../Modal/ModalList';
import {bankCode} from '../../../BankCode.js';

class HqtAddCard extends Component {
	constructor(props){
	  super(props);
	  this.state = {
	    setModalShow: false,
	    cardList: [],
	    cardListCf: [],
	    flag: true,
	    cardName: "",
	    cardNo: "",
	    tranlId: "",
	    bankCodeNo: ""
	  }
	}

	componentDidMount(){
	}
	componentWillUnmount(){
	  
	}
	componentWillMount() {
	  const { dispatch, openHqt, findHqtExist } = this.props;
	  console.log(findHqtExist)
	  const { tradeAccountNo } = findHqtExist;
	  const params = {};
	  const errback = () => {
	    this.setState({
	      flag: false
	    });
	  }
	  const callback = (result) => {
	    this.setState({
	      cardList: result,
	      flag: false
	    });
	    const callbackSec = (result) => {
	      this.setState({
	        cardListCf: result
	      });
	    }
	    dispatch(getCardListByCf(params, callbackSec, errback));
	  }
	  if(openHqt) {
	    dispatch(getCardByHqtOpen(params, callback, errback));
	  }else {
	    const paramsSec = {
	      otsTradeAccountNo: tradeAccountNo
	    }
	    dispatch(getCardByHqt(paramsSec, callback, errback));
	  } 
	}
	 goBack = () => {
	   hashHistory.goBack();
	 }
	showModal = (no, tranlId) => {
	  const { cardListCf } = this.state;
	  if(cardListCf.length > 0) {
	    for(let i = 0; i < cardListCf.length; i++) {
	      if(cardListCf[i].bankCode == no) {
	        this.setState({
	          cardNo: cardListCf[i].bankAccountShowNo,
	          cardName: cardListCf[i].bankName,
	          setModalShow: true,
	          tranlId: tranlId,
	          bankCodeNo: no
	        })
	        break;
	      }else {
	        if(i == cardListCf.length - 1) {
	          this.toNext("", tranlId, no);
	          break;
	        }
	      }
	    }
	  }else {
	    this.toNext("", tranlId, no);
	  }
	}
	hiddenModal = () => {
	    this.setState({
	      setModalShow: false
	    });
	}
	toNext = (num, tranlId, bankCodeNo) => {
	  const { router, callback, isShow, fundCode } = this.props.location.state;
	  let { verifiedUserInfo } = this.props;
	  const { name, certType, certNo, mobileNo } = verifiedUserInfo.content;
	  this.setState({
	    setModalShow: false
	  });
	  console.log(callback,"HqtAddCard---callBack")
	  hashHistory.push({
	    pathname: "/HqtBindCard",
	    state: {
	      bankAccountShowNo: num,
	      paymentChannelId: tranlId,
	      bankAccountName: name,
	      certType: certType,
	      certNo:certNo,
	      router: router,
	      bankCode: bankCodeNo,
	      openHqt: true,
	      mobileNo: mobileNo,
	      callback: callback,
	      isShow: isShow,
	      fundCode: fundCode
	    }
	  })
	}
	render() {
		let openHqt = true;
		const { setModalShow, cardList, flag, cardName, cardNo, tranlId, bankCodeNo } = this.state;
		return (
			<div className="mainBox">
				<NavigatorMain>
					<div className="boxHeader">
					  <div>
					    <img onClick={this.goBack} src={require("../../../img/leftArrow_header.png")} />
					  </div>
					  <div>
					    <span>{ openHqt ? "开通活期通" : "添加银行卡" }</span>
					  </div>
					  <div>
					    
					 </div>
		          </div>
		        </NavigatorMain> 
				<div className="content">
					<div style={{flex: 1}}>
					  {
					    cardList.length > 0 && !flag ?
						<div>
					      <div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
					        <div   style={{fontSize: 13, color: "#5b6370"}}>请选择所属银行</div>
					      </div>
					      {
					        cardList.map((data, index) => {
					          return (
					            <div key={index} style={ styles.container } onClick={() => {this.showModal(data.bankCode, data.paymentChannelId)}}>
					              <img style={{height:24.5,width:24.5}} src={bankCode.ty[data.bankCode]}/>
					              <div style={{flex: 1, paddingLeft: 10}} >{data.paymentChannelName}</div>
					              <img style={styles.rightArrow} src={require('../../../img/rightArrow.png')} />
					            </div>
					          )
					        })
					      }
					      <div style={{marginTop:15,paddingLeft:13,paddingRight:13, paddingBottom: 13}}>
					        <div style={{height:30,fontSize:12}}>温馨提示 :</div>
					        <div style={{color:'rgba(130,138,138,1)',fontSize:12,lineHeight:'12px'}}>同一个银行仅支持一张银行卡开通活期通，如需换卡，请先解绑原银行卡，再重新绑定新卡  </div>
					      </div>
						</div>
					    :
					    cardList.length <= 0 && !flag ?
					    <div style={{paddingLeft: 13,paddingRight:13, paddingTop:20 }}>
					      <div  style={{fontSize:15}}>您所添加的银行卡已满, 暂时无法添加</div>
					    </div>
					    :
					    null
					  }

					</div>
					
				</div>
				{
					setModalShow ?
					<AddCardHqtAlert 
						title={"温馨提示"} 
						content={"您已经在华夏财富绑定过尾号为*" + cardNo.slice(-4) + "的" + cardName + "卡，是否要开通该银行卡活期通？"}
						CloseAler = { ()=> { this.setState({ setModalShow:false }) } }
						handleBtn1 = { () => {this.toNext(cardNo, tranlId, bankCodeNo)} }
						handleBtn2 = { () => {this.toNext("", tranlId, bankCodeNo)} }
						btnfirText="确定"
						btnsecText="其他银行卡"
					/> : null
				}
	
			</div>
		)
	}
}

const styles = {
	centerItems: {
		display: "-webkit-flex",
	  WebkitFlexDirection: 'row',
	  WebkitJustifyContent: 'center',
	  WebkitAlignItems: 'center',
	},
	headerLeftView: {
	  marginTop: 20,
	  height: 44,
	},
	headerMiddleView: {
	  marginTop: 20,
	  height: 44,
	},
	headerRightView: {
	  marginTop: 20,
	  height: 44,
	},
	headerLeftContent: {
	  width: 44,
	},
	headerMiddleContent: {
	  fontSize: 13,
	  color: '#fff',
	  backgroundColor: 'transparent',
	},
	headerRightContent: {
	  width: 44,
	  fontSize: 13,
	  color: '#fff',
	  backgroundColor: 'transparent',
	},
	touchHighlightBtn: {
	  marginTop: 14,
	  marginLeft: 13,
	  marginRight: 13,
	  borderRadius: 20,
	},
	loginView: {
		display: "-webkit-flex",
	  backgroundColor: '#FE492E',
	  height: 40,
	  borderRadius: 20,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
	}, 
	inversedLoginView: {
		display: "-webkit-flex",
	  backgroundColor: '#ffffff',
	  borderColor: '#fe492e',
	  borderStyle: "solid",
	  height: 40,
	  borderWidth: 1,
	  borderRadius: 20,
	  WebkitFlexDirection: 'row',
	  WebkitAlignItems: 'center',
	  WebkitJustifyContent: 'center',
	},
	 rightArrow:{
	    marginRight: -2,
	    width: 44,
	    height: 44,
	 },
	 container: {
	 	display: "-webkit-flex",
	    height: 45,
	    borderBottom:'1px solid rgb(235, 238, 240)',
	    justifyContent: "space-between",
	    alignItems: "center",
	    flexDirection: "row",
	    paddingLeft: 13,
	    paddingRight: 5,
	    backgroundColor: "#fff"
   }
};

function mapStateToProps(state,ownProps) {
  return {
	verifiedUserInfo: state.verifiedUserInfo,
    findHqtExist:state.findHqtExist
  }
}

export default connect(mapStateToProps)(HqtAddCard);


// WEBPACK FOOTER //
// ./src/components/myAssets/myCard/HqtAddCard.js